__turbopack_context__.v({
  "actionsRow": "Header-module-scss-module__0MAM-W__actionsRow",
  "avatar": "Header-module-scss-module__0MAM-W__avatar",
  "avatarContainer": "Header-module-scss-module__0MAM-W__avatarContainer",
  "avatarImage": "Header-module-scss-module__0MAM-W__avatarImage",
  "avatarPlaceholder": "Header-module-scss-module__0MAM-W__avatarPlaceholder",
  "balanceLabel": "Header-module-scss-module__0MAM-W__balanceLabel",
  "balanceRow": "Header-module-scss-module__0MAM-W__balanceRow",
  "balanceRowLink": "Header-module-scss-module__0MAM-W__balanceRowLink",
  "balanceSection": "Header-module-scss-module__0MAM-W__balanceSection",
  "balanceValue": "Header-module-scss-module__0MAM-W__balanceValue",
  "balanceValueDrawer": "Header-module-scss-module__0MAM-W__balanceValueDrawer",
  "bellPlaceholder": "Header-module-scss-module__0MAM-W__bellPlaceholder",
  "bellSlot": "Header-module-scss-module__0MAM-W__bellSlot",
  "bellSlotActive": "Header-module-scss-module__0MAM-W__bellSlotActive",
  "burgerButton": "Header-module-scss-module__0MAM-W__burgerButton",
  "burgerButtonActive": "Header-module-scss-module__0MAM-W__burgerButtonActive",
  "burgerIcon": "Header-module-scss-module__0MAM-W__burgerIcon",
  "divider": "Header-module-scss-module__0MAM-W__divider",
  "drawerBody": "Header-module-scss-module__0MAM-W__drawerBody",
  "drawerBodyGuest": "Header-module-scss-module__0MAM-W__drawerBodyGuest",
  "drawerCloseBtn": "Header-module-scss-module__0MAM-W__drawerCloseBtn",
  "drawerCloseIcon": "Header-module-scss-module__0MAM-W__drawerCloseIcon",
  "drawerLogoImage": "Header-module-scss-module__0MAM-W__drawerLogoImage",
  "drawerLogoLink": "Header-module-scss-module__0MAM-W__drawerLogoLink",
  "drawerTopBar": "Header-module-scss-module__0MAM-W__drawerTopBar",
  "drawerTopBarInner": "Header-module-scss-module__0MAM-W__drawerTopBarInner",
  "header": "Header-module-scss-module__0MAM-W__header",
  "headerTransparentAtTop": "Header-module-scss-module__0MAM-W__headerTransparentAtTop",
  "headroom": "Header-module-scss-module__0MAM-W__headroom",
  "jgglIcon": "Header-module-scss-module__0MAM-W__jgglIcon",
  "jgglLabel": "Header-module-scss-module__0MAM-W__jgglLabel",
  "jgglLink": "Header-module-scss-module__0MAM-W__jgglLink",
  "jgglLinkMobile": "Header-module-scss-module__0MAM-W__jgglLinkMobile",
  "langDesktop": "Header-module-scss-module__0MAM-W__langDesktop",
  "langMobile": "Header-module-scss-module__0MAM-W__langMobile",
  "langMobileRow": "Header-module-scss-module__0MAM-W__langMobileRow",
  "logo": "Header-module-scss-module__0MAM-W__logo",
  "logoContainer": "Header-module-scss-module__0MAM-W__logoContainer",
  "logoImage": "Header-module-scss-module__0MAM-W__logoImage",
  "logoutBtn": "Header-module-scss-module__0MAM-W__logoutBtn",
  "logoutSection": "Header-module-scss-module__0MAM-W__logoutSection",
  "memberBadge": "Header-module-scss-module__0MAM-W__memberBadge",
  "menu": "Header-module-scss-module__0MAM-W__menu",
  "menuItem": "Header-module-scss-module__0MAM-W__menuItem",
  "menuItemActive": "Header-module-scss-module__0MAM-W__menuItemActive",
  "menuItemDisabled": "Header-module-scss-module__0MAM-W__menuItemDisabled",
  "menuLink": "Header-module-scss-module__0MAM-W__menuLink",
  "menuLinks": "Header-module-scss-module__0MAM-W__menuLinks",
  "mobileNav": "Header-module-scss-module__0MAM-W__mobileNav",
  "mobileNavItem": "Header-module-scss-module__0MAM-W__mobileNavItem",
  "mobileNavItemActive": "Header-module-scss-module__0MAM-W__mobileNavItemActive",
  "mobileNavItemDisabled": "Header-module-scss-module__0MAM-W__mobileNavItemDisabled",
  "rightSection": "Header-module-scss-module__0MAM-W__rightSection",
  "textLink": "Header-module-scss-module__0MAM-W__textLink",
  "userAvatar": "Header-module-scss-module__0MAM-W__userAvatar",
  "userAvatarImage": "Header-module-scss-module__0MAM-W__userAvatarImage",
  "userDetails": "Header-module-scss-module__0MAM-W__userDetails",
  "userInfo": "Header-module-scss-module__0MAM-W__userInfo",
  "userInfoDrawer": "Header-module-scss-module__0MAM-W__userInfoDrawer",
  "userMenu": "Header-module-scss-module__0MAM-W__userMenu",
  "userMenuDrawer": "Header-module-scss-module__0MAM-W__userMenuDrawer",
  "userMenuWithNav": "Header-module-scss-module__0MAM-W__userMenuWithNav",
  "userTitleRowDesktop": "Header-module-scss-module__0MAM-W__userTitleRowDesktop",
  "userTitleRowDrawer": "Header-module-scss-module__0MAM-W__userTitleRowDrawer",
  "username": "Header-module-scss-module__0MAM-W__username",
  "usernameDrawer": "Header-module-scss-module__0MAM-W__usernameDrawer",
  "verifiedBadgeMenu": "Header-module-scss-module__0MAM-W__verifiedBadgeMenu",
});
